export enum DBTypes {
  MYSQL,
  POSTGRESQL,
  ORACLE,
  MSSQL,
  MONGODB,
}
